module.exports = __webpack_public_path__ + "static/img/Silhouettes-Homme.26ca782.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/Silhouettes-Homme.svg
// module id = OLQw
// module chunks = 1